<nav [class.floating]="floating">
  <div class="nav-container flex">
    <div class="left-content flex flex-1 justify-start">
      <button class="hidden sm:block" (click)="toggleMenu()">
        <div class="whitespace-nowrap" *ngIf="!menuOpen">{{ 'MENU.TITLE' | translate }}</div>
        <div class="whitespace-nowrap" *ngIf="menuOpen">{{ 'MENU.TITLE_CLOSE' | translate }}</div>
      </button>
      <button class="hidden sm:block" (click)="switchLanguage()">{{ nextLanguage | titlecase }}</button>
      <button class="hidden sm:block">
        <div class="icon" [inlineSVG]="searchOpen ? 'assets/icons/icon28-close.svg' : 'assets/icons/icon28-search.svg'" (click)="toggleSearch()"></div>
      </button>
      <button class="menu-button-mobile sm:hidden" [class.open]="menuOpen" (click)="toggleMenu()">
        <div class="icon" [inlineSVG]="'assets/icons/icon28-plus.svg'"></div>
      </button>
    </div>
    <div class="center-content flex flex-1 justify-center">
      <a class="logo" [routerLink]="['/']" routerLinkActive="router-link-active">
        <div [inlineSVG]="'assets/images/logo.svg'"></div>
      </a>
    </div>
    <div class="right-content flex flex-1 justify-end">
      @if(floating) {
        <div class="hidden sm:block whitespace-nowrap">{{ 'MENU.' + currentRoute + '.TITLE' | uppercase | replaceMinusWithUnderscore | translate }}</div>
      }
      <button class="sm:hidden">
        <div class="icon" [inlineSVG]="'assets/icons/icon28-search.svg'" (click)="toggleSearch()"></div>
      </button>
    </div>
  </div>
</nav>
<app-menu [floating]="floating" [open]="menuOpen || searchOpen" (openChange)="menuOpen = $event; searchOpen = $event" [isSearch]="searchOpen"></app-menu>
